export default {
    methods: {
        snackbar (color, text) {
            this.$store.dispatch('snackbar/show', { color, text })
        }
    }
}